import { render, staticRenderFns } from "./crewfrm.vue?vue&type=template&id=8adbf966"
import script from "./crewfrm.vue?vue&type=script&lang=js"
export * from "./crewfrm.vue?vue&type=script&lang=js"
import style0 from "./crewfrm.vue?vue&type=style&index=0&id=8adbf966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports